import React from 'react';
import { IconButton } from '@mui/material';
import { colors } from '@roku-web-ui/rds-theme';

import { IconMotionTracking } from 'components/icons';
import { Tooltip } from 'components/common/Tooltip';
import { useAspenLogger } from 'hooks/useAspenLogger';
import { useAspenSocket } from 'hooks/useAspenSocket';

import { AppLeaf } from 'types/common/leaf';

interface MotionTrackingProps {
  leaf: AppLeaf;
}

export const MotionTracking = ({ leaf }: MotionTrackingProps) => {
  const { logAspenEvent } = useAspenLogger();

  const motionTracking = leaf?.settings?.motionTracking;
  const { updateSettings } = useAspenSocket();

  return (
    <Tooltip title="Motion tracking" placement="top">
      <IconButton
        aria-label="motion-tracking"
        data-testid="button-motion-tracking"
        onClick={() => {
          updateSettings({
            leaf,
            settings: { motionTracking: !motionTracking },
          });

          logAspenEvent({
            log_id: 'iot.web.stream.interaction',
            payload: {
              device_id: leaf?.id,
              interaction: 'motion_tracking',
            },
          });
        }}
        sx={{
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        <IconMotionTracking sx={{ color: motionTracking ? colors.purple[500] : colors.grey[400] }} />
      </IconButton>
    </Tooltip>
  );
};
